import { Button, Icon, makeStyles, Tab, Tabs } from "@material-ui/core";
import { useCatalogStore } from "application/contexts/catalog/CatalogStore";
import { useIdle } from "application/contexts/idle/IdleContext";
import { useKiosk } from "application/contexts/kiosk/KioskContext";
import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import { useUi } from "application/contexts/ui/UIContext";
import React, {
  CSSProperties,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { hexToRGBA } from "utils/utils";
import { useAdmin } from "../../application/contexts/admin/adminContext";
import { ReactComponent as Reload } from "../../assets/icons/reload.svg";
import meeLogo from "../../assets/images/logo-mee-purple.png";
import meepLogo from "../../assets/images/logo-meep-novo.png";
import styles from "./Admin.module.scss";
import { AuthOperator } from "./authOperator/AuthOperator";
import { BetaSettings } from "./beta/BetaSettings";
import { KioskParameters } from "./kioskParameters/KioskParameters";
import { OrderLogViewV3 } from "./orderLog/OrderLogViewV3";
import { PendingPixList, usePaymentHistory } from "./pendingPix/PendingPixList";

const useStyles = makeStyles({
  indicator: {
    display: "none",
  },
  selected: {
    background: "green",
  },
  root: {
    background: "red",
  },
});

export const Admin = () => {
  const classes = useStyles();
  const { isAuthOperator } = useAdmin();
  const history = useHistory();
  const { hideLoading, showLoading } = useUi();
  const { forceSync } = useCatalogStore();
  const { handleActiveIdleTimer } = useIdle();
  const { kiosk } = useKiosk();
  const { resolution } = useScreenStore();

  const [tabIndex, settabIndex] = useState(0);
  const hasPendingPix = usePaymentHistory().length > 0;

  useEffect(() => {
    if (!hasPendingPix && tabIndex === 3) {
      settabIndex(0);
    }
  }, [hasPendingPix, tabIndex]);

  const syncCatalog = useCallback(async () => {
    showLoading();
    try {
      await forceSync(kiosk?.worksWithEvents ? kiosk?.eventId : undefined);
      window.location.reload();
    } finally {
      hideLoading();
    }
  }, [forceSync, hideLoading, kiosk, showLoading]);

  useEffect(() => {
    handleActiveIdleTimer();
  }, [handleActiveIdleTimer]);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    settabIndex(newValue);
  };
  const goBack = useCallback(() => {
    history.replace("/");
  }, [history]);

  const onImgError = useCallback(
    (ev: React.ChangeEvent<HTMLImageElement>) => {
      ev.target.src = (kiosk?.isMee || kiosk?.isMeeConsulting) ? meeLogo : meepLogo;
    },
    [kiosk]
  );

  const logo = useMemo(
    () => (kiosk?.isMee || kiosk?.isMeeConsulting ? meeLogo : meepLogo),
    [kiosk]
  );

  return (
    <div id={styles.Admin}>
      <div className={styles.toolbar}>
        <div>
          <Icon fontSize="large" className={styles.goBack} onClick={goBack}>
            chevron_left
          </Icon>
        </div>
        <img
          src={logo}
          alt="Logo"
          onErrorCapture={onImgError}
          style={{
            height: resolution === ResolutionType.FULL_HD ? 100 : 70,
            width:
              resolution === ResolutionType.FULL_HD
                ? kiosk?.isMee || kiosk?.isMeeConsulting
                  ? 220
                  : 320
                : kiosk?.isMee || kiosk?.isMeeConsulting
                  ? 200
                  : 250,
          }}
        />
        <Button
          style={{
            background: hexToRGBA(
              kiosk?.themeColor ?? kiosk?.primaryColor ?? "#FFFFFF",
              0.1
            ),
          }}
          onClick={syncCatalog}
        >
          <Reload /> Atualizar dados
        </Button>
      </div>
      {isAuthOperator ? (
        <div className={styles.container}>
          <div className={styles.tab}>
            <Tabs
              value={tabIndex}
              onChange={handleChangeTab}
              aria-label="simple tabs example"
              classes={{
                indicator: classes.indicator,
              }}
            >
              <Tab
                label="Dados Gerais"
                classes={{
                  root:
                    tabIndex === 0
                      ? styles.customTabSelected
                      : styles.customTab,
                }}
                style={
                  {
                    "--color": "var(--primary)",
                  } as CSSProperties
                }
              />
              <Tab
                label="Histórico"
                classes={{
                  root:
                    tabIndex === 1
                      ? styles.customTabSelected
                      : styles.customTab,
                }}
                style={
                  {
                    "--color": "var(--primary)",
                    marginLeft: 16,
                  } as CSSProperties
                }
              />
              <Tab
                label="Beta"
                classes={{
                  root:
                    tabIndex === 2
                      ? styles.customTabSelected
                      : styles.customTab,
                }}
                style={
                  {
                    "--color": "#7f47dd",
                    marginLeft: 16,
                  } as CSSProperties
                }
              />
              {hasPendingPix && (
                <Tab
                  label="Pagamentos"
                  classes={{
                    root:
                      tabIndex === 3
                        ? styles.customTabSelected
                        : styles.customTab,
                  }}
                  style={
                    {
                      "--color": "var(--primary)",
                      marginLeft: 16,
                    } as CSSProperties
                  }
                />
              )}
            </Tabs>
            
          </div>
          {tabIndex === 0 && <KioskParameters />}
          {tabIndex === 1 && <OrderLogViewV3 />}
          {tabIndex === 2 && <BetaSettings />}
          {tabIndex === 3 && hasPendingPix && <PendingPixList />}
        </div>
      ) : (
        <AuthOperator></AuthOperator>
      )}

    </div>
  );
};
